import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import MyUnsplash from "../../Assets/myUnsplashHomePage.jpeg";
import { motion } from "framer-motion";

function Projects() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.99 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0 }}
      transition={{ ease: "easeIn", duration: 1 }}
    >
      <Container fluid className="project-section">
        <Container>
          <h1 className="project-heading">
            My Recent <strong className="purple">Works </strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects I've worked on recently.
          </p>
          <p style={{ color: "white" }}>Here are a project I've worked on.</p>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={MyUnsplash}
                title="My Unsplash"
                description="Explore a platform where you can share your own images, delete them if you wish, and also discover the work of other users. You can also easily search for other users' images using their name."
                live={true}
                repositoryLink="https://github.com/emily883/Unsplash"
                liveLink="https://pandasplash.netlify.app/"
                front={["VueJS","CSS3 Modules"]}
                back={["TypeScript"," NodeJs","ExpressJs"]}
              />
            </Col>
            {/*<Col md={4} className="project-card">*/}
            {/*  <ProjectCard*/}
            {/*    imgPath={Interpreter}*/}
            {/*    title="Lox Interpreter"*/}
            {/*    description="I developed an interpreter written in Java for the Lox programming language, which allows users to run Lox programs in an interactive console, as well as to pass a file as a parameter."*/}
            {/*    live={false}*/}
            {/*    repositoryLink="https://github.com/emily883/lox-interpreter"*/}
            {/*    back={["Java"]}*/}
            {/*    front={["Console/Terminal"]}*/}
            {/*  />*/}
            {/*</Col>*/}
          </Row>
        </Container>
      </Container>
    </motion.div>
  );
}

export default Projects;
